// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"34":"airships","313":"submarines"}[chunkId] || chunkId) + "." + {"34":"05b1b5bd","313":"d263c229","906":"b4d8b476"}[chunkId] + ".js";
};